<template>

  <v-col cols="12" md="6" lg="3">
    <v-sheet class="rounded-lg">
      <div class="image-wrapper">
          <img :src="image || placeholderImage" alt="Partner Image" class="image rounded-t-lg">
      </div>
      <v-container>
        <v-row>
          <v-col cols="12" class="py-0">
            <p v-if="subcategory != undefined" class="badge-subcategory">{{ subcategory }}</p>
            <p v-else class="badge-subcategory empty">&nbsp;</p>
          </v-col>
          <v-col cols="12" class="pb-0">
            <p v-if="benefit" class="benefit">{{ benefit }}</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <h3 class="title">{{ name }}</h3>
          </v-col>
          <v-col cols="12">
            <div class="button-wrapper">
              <button class="button" @click="showPartnerInfo">Saiba Mais</button>
            </div>
            <p class="states">
              <img :src="pinEstadosParceiros" />
              {{ states }}
            </p>
          </v-col>
        </v-row>
      </v-container>

    </v-sheet>
  </v-col>

  <v-dialog
    v-model="showPartnerModal"
    width="800"
    max-width="95%" 
  >
    <div class="partner-modal">
      <v-container>
        <v-icon class="icon-close" @click="showPartnerModal=false">mdi-close-circle</v-icon>
        <v-row>
          <v-col cols="12" md="5">
            <div class="image-wrapper">
              <img :src="image || placeholderImage" alt="Partner Image" class="image rounded-lg">
            </div>
          </v-col>
          <v-col cols="12" md="7">
            <v-row>
              <v-col cols="6">
                <p v-if="benefit" class="benefit">{{ benefit }}</p>
              </v-col>
            </v-row>
            <h3 class="title2">{{ name }}</h3>
            <v-row  v-if="subcategory != undefined">
              <v-col cols="12">
                <p class="badge-subcategory">{{ subcategory }}</p>
              </v-col>
            </v-row>
            <p class="states">
              <img :src="pinEstadosParceiros" />
              {{ states }}
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <h4 class="detalhe-beneficio-titulo">DETALHES DO BENEFÍCIO</h4>
            <div class="detalhe-beneficio-texto" v-html="details"></div>
          </v-col>
          <v-col v-if="store.customer.isLoggedIn" cols="12">
            <button class="coupon">{{ coupon }}</button>
            <h4 class="regra-beneficio-titulo">REGRAS DO BENEFÍCIO</h4>
            <div class="regra-beneficio-texto" v-html="rules"></div>
          </v-col>
          <v-col v-else>
            <a href="/#login" class="button">Faça login para saber mais</a>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-dialog>

</template>

<script setup>
import { inject, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from '@/stores';
import pinEstadosParceiros from '@/assets/pinEstadosParceiros.svg';

const placeholderImage = require('@/assets/whiteLogo.svg');
const axios = inject('axios');
const backendUrl = inject('backendUrl');
const store = useStore();
const router = useRouter();
const showPartnerModal = ref(false);

const props = defineProps({
    id: {
        type: Number,
        required: true,
    },
    image: {
        type: String,
        required: true,
    },
    name: {
        type: String,
        required: true,
    },
    benefit: {
        type: String,
        required: true,
    },
    states: {
        type: String,
        default: '',
    },
    details: {
        type: String,
        default: '',
    },
    rules: {
        type: String,
        default: '',
    },
    coupon: {
        type: String,
        default: '',
    },
    subcategory: {
        type: String,
        default: '',
    },
});

const showPartnerInfo = () => {
  showPartnerModal.value = true;
}

</script>

<style scoped lang="scss">
.card-parceiro {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-basis: 335px;
    border: none;
    border-radius: 15px;
    overflow: hidden;
    cursor: pointer;
    max-width: 535px;
    min-width: 335px;
    min-height: 400px;
    background-color: white;
    box-shadow: 0 1px 2px -1px rgba(0,0,0,0.3);
    @media (max-width: 676px) {
        max-width: 335px;
    }
}

.image-wrapper {
  display: flex;
  width:100%;
}

.image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    padding: 8px 16px;
}

.title {
    font-size: 18px;
    text-align: left;
    margin-left: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-height: 1.2;
    height: 55px;
  }

.title2 {
    font-size: 18px;
    text-align: left;
    margin: 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

.states {
    display: flex;
    align-items: center;
    font-size: 14px;
    text-align: left;
    color: gray;
    margin: 0.7em 0;
    img {
        margin-right: 6px;
    }
}

.button-wrapper {
    display: flex;
}

.button {
    width: 100%;
    background-color: $verde-opus;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    text-align: center;
    cursor: pointer;
}

.coupon {
    width: 100%;
    font-size: 14px;
    background-color: lightGray;
    color: black;
    padding: 8px 16px;
    border: none;
    border-radius: 20px;
    text-align: center;
}

.badge-subcategory {
	display: inline-block;
  float:left;
  background-color: none;
  color: $verde-opus;
  margin: 2px;
  padding: 3px 8px;
  border: 2px solid $verde-opus;
  border-radius: 20px;
  text-align: center;
  font-size: 12px;
}
.badge-subcategory.empty {
	opacity: 0;
}

.benefit {
    font-size: 14px;
    color: black;
    background-color: gold;
    border-radius: 20px;
    padding: 5px 15px;
    text-align: center;
}

.partner-modal {
  background-color: white;
  border-radius: 10px;
  border: 2px solid $verde-opus;
  padding: 10px;
  box-shadow: 0 1px 2px -1px rgba(0,0,0,0.3);
}

.partner-modal .detalhe-beneficio-titulo {
  line-height:0.5;
  font-size: 18px;
  color: black;
  border-bottom: 2px solid $verde-opus;
  margin: 0 0 15px 0;
  padding: 0 0 10px 0;
}
.partner-modal .regra-beneficio-titulo {
  line-height:0.5;
  font-size: 14px;
  color: gray;
  margin: 20px 0 15px 0;
  padding: 0 0 10px 0;
}
.partner-modal .icon-close {
    color:#ffb300;
    float:right;
}

</style>

<!-- html carregado dinamicamente não pode ser scoped -->
<style lang="scss">
.partner-modal .detalhe-beneficio-texto {
  font-size: 12px !important;
  color: black !important;
  p, ul, ol {
    font-size: 12px !important;
    color: black !important;
  }
}
.partner-modal .regra-beneficio-texto {
  font-size: 8px;
  color: gray;
  p, ul, ol {
    font-size: 8px;
    color: gray;
  }
}
</style>
